import { PendencyReasonInteractor, PendencyReasonRequest, PendencyReasonStructRequest } from "../../Coordinator/PendencyReason/PendencyReasonInteractor";

export class PendencyReasonViewModel {
	private interactor: PendencyReasonInteractor;

	constructor() {
		this.interactor = new PendencyReasonInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new PendencyReasonRequest(
			obj["sgepdenguependencia"] ? parseInt(obj["sgepdenguependencia"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new PendencyReasonStructRequest(obj["sgepdenguependencia"] ? parseInt(obj["sgepdenguependencia"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}